import { render, staticRenderFns } from "./MemberForm.vue?vue&type=template&id=229a4f12&scoped=true&"
import script from "./MemberForm.vue?vue&type=script&lang=ts&"
export * from "./MemberForm.vue?vue&type=script&lang=ts&"
import style0 from "./MemberForm.vue?vue&type=style&index=0&id=229a4f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229a4f12",
  null
  
)

export default component.exports